import { createAction, handleActions } from 'redux-actions';
import api from 'api';
import util from 'util/baseUtil';

/* 상수 값 */
const rows = 50;  //페이지당 글 수

/* 액션 생성 */
const CLEAR_CHAT_LIST = 'chat/CLEAR_CHAT_LIST';
const GET_LIST_CHAT_DB = 'chat/GET_LIST_CHAT_DB';
const GET_LIST_CHAT_DB_SUCCESS = 'chat/GET_LIST_CHAT_DB_SUCCESS';
const GET_LIST_CHAT_DB_ERROR = 'chat/GET_LIST_CHAT_DB_ERROR';
const SET_CHAT_LIST = 'chat/SET_CHAT_LIST';

const SET_ACTIVE_CHANNEL = 'chat/SET_ACTIVE_CHANNEL';
const CLEAR_ACTIVE_CHANNEL = 'chat/CLEAR_ACTIVE_CHANNEL';
const UPDATE_ACTIVE_CHANNEL = 'chat/UPDATE_ACTIVE_CHANNEL';



export const clearChatList = createAction(CLEAR_CHAT_LIST);
export const updateActiveChannel = createAction(UPDATE_ACTIVE_CHANNEL);


const getIdChatBundle = (chat, inRoom) => {
  let id = `${chat.reg_date.substring(0,16)}_${chat.room_id}`
  if (inRoom) {
    id += `_${chat.owner_id}`;
  }

  return id;
}


const makeListItem = (chat, inRoom) => {
  return {
    id: getIdChatBundle(chat, inRoom),
    key: `${chat.reg_date}_${chat.room_id}`,
    date: chat.reg_date,
    roomInfo: {
      room_id: chat.room_id,
      room_name: chat.room_name,
      room_owner_id: chat.room_owner_id,
      room_profile_image: chat.room_profile_image,
      user_count: chat.user_count,
      room_shortid: chat.room_shortid,
    },
    writerInfo: inRoom ? {
      owner_id: chat.owner_id,
      sender_name: chat.sender_name,
      staff_msg: chat.staff_msg,
      profile_image: chat.profile_image,
    } : null,
    contents: [chat],
  }
}


export const appendChatList = params => async (dispatch, getState) => {

  if (!params) {
    return;
  }

  let list = [...getState().chat.list];
  let targetList;
  if (Array.isArray(params)) {
    targetList = [...params];
  } else {
    targetList = [params];
  }
  
  if (targetList.length === 0) {
    return;
  }

  const inRoom = getState().chat.activeChannel.room_id ? true : false;

  targetList.forEach(target => {
    let last = list[list.length - 1];
    if (last && last.id === getIdChatBundle(target, inRoom)) {
      //기존에 추가.
      last.contents = [...last.contents, target];
      list[list.length - 1] = {...last};
    } else {
      //생성
      list.push(makeListItem(target, inRoom));
    }
  });

  dispatch({ type: SET_CHAT_LIST, payload: list });
}



export const prependChatList = params => async (dispatch, getState) => {
  
  if (!params) {
    return;
  }

  let list = [...getState().chat.list];
  let targetList;
  if (Array.isArray(params)) {
    targetList = [...params];
  } else {
    targetList = [params];
  }
  
  if (targetList.length === 0) {
    return;
  }

  const inRoom = getState().chat.activeChannel.room_id ? true : false;

  targetList.forEach(target => {
    let first = list[0];
    if (first && first.id === getIdChatBundle(target, inRoom)) {
      //기존에 추가.
      first.contents = [target, ...first.contents];
      list[0] = {...first};
    } else {
      //생성
      list.unshift(makeListItem(target, inRoom));
    }
  });

  dispatch({ type: SET_CHAT_LIST, payload: list });
}



const getListChat = async (dispatch, getState, params) => {
  if (params.page === 0) {
    dispatch({ type: CLEAR_CHAT_LIST });
  } else if (getState().chat.db.isLastPage || getState().chat.db.loading) {
    return;
  }
  
  dispatch({ type: GET_LIST_CHAT_DB });

  try {
    const responseData = await api.chat.getChatList(params);
    const { result } = responseData;
    if (result === 'S') {
      dispatch(appendChatList(responseData.chatList));
      const length = responseData.chatList.length;
      
      let isLastPage = false;
      let last_cid = getState().chat.db.last_cid;
      let last_reg_date = getState().chat.db.last_cid;
      if (length > 0) {
        const lastChatData = responseData.chatList[length - 1]
        last_cid = lastChatData.cid;
        last_reg_date = lastChatData.reg_date.substring(0, 19)
      } else {
        isLastPage = true;
      }
      dispatch({ type: GET_LIST_CHAT_DB_SUCCESS, payload: {
        isLastPage: isLastPage,
        last_cid: last_cid,
        last_reg_date: last_reg_date,
      } });
    } else {
      dispatch({ type: GET_LIST_CHAT_DB_ERROR, payload: '[500] 서버에러' });
      alert('서버에러. 관리자에게 문의 주세요.')
    }
  } catch(e) {
    if (e.message !== 'cancel' && e.response.status !== 403) {
      dispatch({ type: GET_LIST_CHAT_DB_ERROR, payload: `[${e.response.status}] ${e.message}` });
      throw e;
    }
  }
}


/**
 * 채팅목록 불러오기
 * @param {*} params {room_id: 채널아이디.(옵셔널)}
 */
export const loadChat = params => async (dispatch, getState) => {
  getListChat(dispatch, getState, {...params, page: 0, last_cid: '', last_reg_date: '', rows: rows});
}


/**
 * 채팅목록 더 불러오기(다음페이지)
 * @param {*} params {room_id: 채널아이디.(옵셔널)}
 */
export const loadMoreChat = params => async (dispatch, getState) => {
  getListChat(dispatch, getState, {...params, last_cid: getState().chat.db.last_cid, last_reg_date: getState().chat.db.last_reg_date, rows: rows});
}


/**
 * 활성 채널 변경
 * @param {*} params 
 */
export const changeActiveChannel = params => async (dispatch, getState) => {
  if (params && params.room_id === getState().chat.activeChannel.room_id) { 
    return;
  }

  dispatch({ type: CLEAR_CHAT_LIST });

  if (!params || !params.room_id) {
    dispatch({ type: CLEAR_ACTIVE_CHANNEL });
    return;
  }

  dispatch({ type: SET_ACTIVE_CHANNEL, payload: params });

  
  try {
    const responseData = await api.user.get({userid: params.room_owner_id});
    dispatch({ type: UPDATE_ACTIVE_CHANNEL, payload: { owner_name: responseData.user.username } });
  } catch(e) {
    console.log(e)
  }
}


/**
 * 활성채널 유저 숫자 갱신(유효성 체크 포함.)
 * @param {*} params {room_id: 채널아이디, user_count: 유저 숫자}
 */
export const updateUserCount = params => async (dispatch, getState) => {
  const { room_id, user_count } = params;
  if (getState().chat.activeChannel.room_id !== room_id) {
    return;
  }

  dispatch({ type: UPDATE_ACTIVE_CHANNEL, payload: { user_count } });
}


/**
 * 기본 채널로 이동
 */
export const goDefaultChannel = () => async (dispatch, getState) => {
  if (getState().chat.activeChannel.room_id) {
    dispatch(changeActiveChannel())
  } else {
    dispatch(loadChat({room_id: ''}));
    util.scrollToTop()
  }
}


/**
 * 메시지 컨트롤(포스트 숨김-표시)
 */
export const msgControl = params => async (dispatch, getState) => {
  const currentRoomId = getState().chat.activeChannel.room_id;
  const inRoom = currentRoomId ? true : false;
  const id = getIdChatBundle(params, inRoom);
  let itemChange = false;
  let list = getState().chat.list.map(item => {
    if (item.id !== id) {
      return item;
    }

    // 컨텐츠 비교
    let contentsChange = false;
    let contents = item.contents.map(cont => {
      if (cont.chat_id !== params.chat_id) {
        return cont;
      }
      contentsChange = true;
      itemChange = true;
      return {
        ...cont,
        web_post_hide_yn: params.web_post_hide_yn,
      }
    });

    // 컨텐츠가 안바뀌었으면 그대로
    if (!contentsChange) {
      return item;
    }

    return {
      ...item,
      contents: contents,
    }
  });

  // 바뀐 리스트아이템이 없으면 그대로 종료
  if (!itemChange) {
    return;
  }

  // 바뀌었으면 state갱신
  dispatch({ type: SET_CHAT_LIST, payload: list });
  
}


/* 초기상태 설정(immutable) */
const initialState = {
  list: [],
  db: {
    data: [],
    loading: false,
    isLastPage: false,
    last_cid: '',
    last_reg_date: '',
    error: null,
  },
  sock: {
    data: [],
    lastAddedChatId: null,
  },
  activeChannel: {
    room_id: '',
    room_name: '',
    owner_id: '',
    owner_name: '',
    user_count: 0,
  },
};

/* 리듀서 정의 */
export default handleActions({
  [CLEAR_CHAT_LIST]: (state, action) => {
    return {
      ...state,
      list: initialState.list,
      db: {
        ...initialState.db
      },
      sock: {
        ...initialState.sock
      },
    }
  },
  [GET_LIST_CHAT_DB]: (state, action) => {
    return {
      ...state,
      db: {
        ...state.db,
        loading: true,
      },
    }
  },
  [GET_LIST_CHAT_DB_SUCCESS]: (state, action) => {
    const { isLastPage, last_cid, last_reg_date } = action.payload;
    return {
      ...state,
      db: {
        ...state.db,
        loading: false,
        isLastPage: isLastPage,
        last_cid: last_cid,
        last_reg_date: last_reg_date,
      },
    }
  },
  [GET_LIST_CHAT_DB_ERROR]: (state, action) => {
    return {
      ...state,
      db: {
        ...state.db,
        loading: false,
        error: action.payload,
      },
    }
  },
  [SET_CHAT_LIST]: (state, action) => {
    return {
      ...state,
      list : action.payload,
    }
  },

  [SET_ACTIVE_CHANNEL]: (state, action) => {
    const {room_id, room_name, owner_id, owner_name, user_count} = action.payload;

    return {
      ...state,
      activeChannel: {room_id, room_name, owner_id, owner_name, user_count},
    }
  },
  [CLEAR_ACTIVE_CHANNEL]: (state, action) => {
    return {
      ...state,
      activeChannel: {
        ...initialState.activeChannel,
      },
    }
  },
  [UPDATE_ACTIVE_CHANNEL]: (state, action) => {
    return {
      ...state,
      activeChannel: {
        ...state.activeChannel,
        ...action.payload,
      },
    }
  },
}, initialState)